<template>
  <div class="salesupply_skeleton d-flex flex-column flex-lg-row h-screen">
    <div class="container my-5">
      <slot />
    </div>
  </div>
</template>

<script setup>
useHead({
  script: [
    {
      src: 'https://kit.fontawesome.com/a31fdd295d.js',
      crossorigin: 'anonymous',
    },
  ],
  meta: [{ name: 'color-scheme', content: 'light' }],
});
</script>
